import { render, staticRenderFns } from "./Reference.vue?vue&type=template&id=10e87ec1&scoped=true"
import script from "./Reference.vue?vue&type=script&lang=js"
export * from "./Reference.vue?vue&type=script&lang=js"
import style0 from "./Reference.vue?vue&type=style&index=0&id=10e87ec1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e87ec1",
  null
  
)

export default component.exports